// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__2SBUx","bottom":"style_bottom__202r2"};